module.exports = __webpack_public_path__ + "img/PROCESS.afe1b5da.svg";